export default __webpack_public_path__ + "static/media/reactBank.4588e095.png";